<template>
  <main>
    <voucher-segment-list :infinite-id="infiniteId"
                          @reload="reload" />
  </main>
</template>

<script>
import VoucherSegmentList from "@components/modules/voucher/segment/list/VoucherSegmentList.vue";
import EventBus from "@packages/event-bus";

export default {
  components: {
    VoucherSegmentList,
  },

  data() {
    return {
      infiniteId: +new Date(),
    };
  },
  mixins: [],

  props: {},

  mounted() {
    EventBus.$on("VOUCHER_SEGMENT_CREATED", this.reload);
  },

  methods: {
    async reload() {
      this.infiniteId++;
    },
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
</style>